import clsx from "clsx";
import { DropdownArrowIcon } from "@assets/icons";

export default function NavArrow({ right = false, onClick }) {
    const handleClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick();
    };

    return (
        <DropdownArrowIcon
            onClick={handleClick}
            fill="#fff8"
            className={clsx(
                "h-[8px] cursor-pointer ",
                right ? " right-0 rotate-[270deg]" : " rotate-90",
            )}
        />
    );
}
